import { BUILDINGS_QUERY_KEY } from '@domain/buildings';
import { VENUES_QUERY_KEY } from '@domain/venues';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { deleteBuilding } from '@services/buildings/buildingsService';
import { useQueryClient } from 'react-query';

const useDeleteBuilding = (
  venueId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (buildingId) => deleteBuilding(buildingId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BUILDINGS_QUERY_KEY(venueId));
        queryClient.invalidateQueries(VENUES_QUERY_KEY);
      }
    }
  );
};

export { useDeleteBuilding };
